import React from 'react'
import './talks-conferences.scss'

import CardSpecialist from '../../atoms/card-specialist/card-specialist'

const talksConferences = (props) => {
  const { talksInfo, isMobile, isCompleted = false, isSecondStyle = false } = props

  return (
    <div className="m-talks" id="agenda">
      <div className="m-talks__title">
        <h3>Charlas y conferencias</h3>
      </div>
      <div className="m-talks__cards">
        <CardSpecialist isSecondStyle={isSecondStyle} talksInfo={talksInfo} isMobile={isMobile} isCompleted={isCompleted} webinarInfo={props.webinarInfo} />
      </div>
    </div>
  )
}

export default talksConferences
